// Shared invoice payment presentation helpers (used by InvoicesPage list
// and by the invoice detail view). Single source so both stay in sync.
export const fmtMoney = (n) => (n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const PAYMENT_METHOD_COLORS = {
  cash: 'bg-emerald-50 border-emerald-200 text-emerald-700',
  check: 'bg-blue-50 border-blue-200 text-blue-700',
  credit_card: 'bg-amber-50 border-amber-200 text-amber-700',
  zelle: 'bg-purple-50 border-purple-200 text-purple-700',
  ach: 'bg-cyan-50 border-cyan-200 text-cyan-700',
};

export const PAYMENT_METHOD_LABELS = {
  cash: 'Cash', check: 'Check', credit_card: 'Credit Card', zelle: 'Zelle', ach: 'ACH / Transfer',
};
